import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AssistanceService } from 'app/shared/services/assistance-service';
import { IApiSessionLogin } from 'app/shared/lib/api/api-session-types';
import { LoginContext } from 'app/shared/lib/login-context';
import { VerifyBy, VerificationMethods } from 'app/shared/models/assistance-models';

@autoinject()
export class VerifyViewModel {

    public readonly method: VerifyBy = 'email';
    public code: string = '';
    public errorMessage: string = '';

    public verified: boolean = false;
    public logins: IApiSessionLogin[] = [];

    protected methods = VerificationMethods;

    constructor(
        private readonly router: Router,
        private readonly logger: AppLogger,
        private readonly loginContext: LoginContext,
        private readonly service: AssistanceService) {
        this.logger.source = this;
        this.logger.target = 'console';
    }

    protected navigateToLogin() {
        this.router.navigateToRoute('checkin', { code: this.code });
    }
}
